export default __webpack_public_path__ + "static/face-verification-f580b8a38e060ccfdb77a64f2ee58540.png";